import { authModules } from 'app/auth';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import ABSAdministrationChildsRoutes from './childs/ABSAdministrationChildsRoutes';
import ABSUtils from '@abs/utils/ABSUtils';
import i18next from 'i18next';
import enGB from '@locales/absadministration/enGB';
import deAT from '@locales/absadministration/deAT';

i18next.addResourceBundle('enGB', 'absadministration', enGB);
i18next.addResourceBundle('deAT', 'absadministration', deAT);

const ABSAdministrationLayout = lazy(() => import('./ABSAdministrationLayout'));

const ABSAdministrationConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/administration',
			element: <ABSAdministrationLayout />,
			auth: authModules.abs_admin,
			children: [
				...ABSAdministrationChildsRoutes,
				{
					path: '/administration',
					element: () => <Navigate to="/administration/overview" />
				}
			]
		}
	]
};

export default ABSAdministrationConfig;
